import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 75;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-black border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="space-y-4">
            <div className="text-2xl font-bold tracking-wider mb-4">
              <span className="text-white">RAIDER </span>
              <span className="text-[#CC0000]">WASHING</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Crystal Clear Results
            </p>
            <p className="text-gray-400 leading-relaxed">
              Professional window cleaning serving Lubbock and the South Plains. 
              Started and owned by Texas Tech University students.
            </p>
          </div>

          {/* Column 2 - Services */}
          <div>
            <h3 className="font-['Bebas_Neue'] text-2xl text-white mb-4 tracking-wide">
              Services
            </h3>
            <div className="space-y-2">
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                Residential Windows
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                Hard-to-Reach Windows
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                Sill & Frame Cleaning
              </button>
              <button 
                onClick={() => scrollToSection('results')}
                className="block text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                View Results
              </button>
            </div>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="font-['Bebas_Neue'] text-2xl text-white mb-4 tracking-wide">
              Contact Us
            </h3>
            <div className="space-y-3">
              <a 
                href="mailto:raiderwashing@gmail.com"
                className="flex items-center gap-3 text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                <Mail size={18} />
                <span>raiderwashing@gmail.com</span>
              </a>
              <a 
                href="tel:+19728321657"
                className="flex items-center gap-3 text-gray-400 hover:text-[#CC0000] transition-colors duration-300"
              >
                <Phone size={18} />
                <span>(972) 832-1657</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin size={18} />
                <span>Lubbock, TX & surrounding areas</span>
              </div>
            </div>
            <button 
              onClick={() => scrollToSection('quote')}
              className="mt-6 bg-[#CC0000] text-white px-6 py-2.5 rounded hover:bg-[#B30000] transition-all duration-300 font-semibold shadow-lg hover:shadow-red-900/50"
            >
              Free Quote
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-900 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-500 text-sm">
            <div>
              © 2025 Raider Washing. All rights reserved.
            </div>
            <div>
              Founded by Texas Tech Students · Lubbock, TX
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
